(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-availability-filter"] && !Shopify.designMode) return;
  try {
    function initializeAlmaAvailabilityFilters() {
    document.querySelectorAll('[data-alma-availability]').forEach((select) => {
      if (select.dataset.almaAvailabilityInitialized === 'true') return;
      select.dataset.almaAvailabilityInitialized = 'true';
      const current = new URL(window.location.href);
      const values = current.searchParams.getAll('filter.v.availability').flatMap((value) => value.split(','));
      select.value = values.includes('1') && !values.includes('0') ? '1' : '';
      select.addEventListener('change', () => {
        const destination = new URL(window.location.href);
        destination.searchParams.delete('page');
        destination.searchParams.delete('filter.v.availability');
        if (select.value === '1') {
          destination.searchParams.set('filter.v.availability', '1');
        }
        window.location.assign(destination.href);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAlmaAvailabilityFilters, { once: true });
  } else {
    initializeAlmaAvailabilityFilters();
  }
  document.addEventListener('shopify:section:load', initializeAlmaAvailabilityFilters);
  } catch(e) { console.error(e); }
})();

})();
